export default {
  // 物流公司
  LOGISTICS_COMPANY: [
    {
      value: "BEST",
      label: "百世快递"
    },
    {
      value: "ZTO",
      label: "中通快递"
    },
    {
      value: "YTO",
      label: "圆通快递"
    },
    {
      value: "EMS",
      label: "邮政快递"
    },
    {
      value: "STO",
      label: "申通快递"
    },
    {
      value: "JD",
      label: "京东快递"
    },
    {
      value: "YUN_DA_PARTNER",
      label: "韵达快递"
    },
    {
      value: "DAY_DAY",
      label: "天天快递"
    },
    {
      value: "SF",
      label: "顺丰快递"
    },
    {
      value: "OTHER",
      label: "其他"
    },
    {
      value: "NONE",
      label: "暂未发货"
    }
  ]
};
